var SJ = SJ || {};
var __ = __ || function (str) {
    return str;
};
var i18nLang = i18nLang || 'en';

SJ.Sites = SJ.Sites || {
    init: function () {

        // Dropdown navigation
        SJ.Sites.dropdown_menu();
        var bodyElement = $('body');
        // Comments

        $(document).on('change', 'select[name="mobile_app_link_mode"]', function () {
            var mobile_app_link_urls = $('#mobile_app_link_urls');
            if(parseInt($(this).val())===1){
                mobile_app_link_urls.removeClass('ui-helper-hidden');
            }
            else{
                mobile_app_link_urls.addClass('ui-helper-hidden');
            }
        });

        $(document).on('click', '.approve-comments, .unapprove-comments', function (e) {

            var approve = $(this).hasClass('approve-comments'),
                all = $(this).hasClass('comments-all');

            var comment_ids = [];

            $(this).parent().parent().parent().parent().find(':checkbox').each(function () {
                if ( all ) {
                    if ( $(this).hasClass('select_all') || $(this).prop('checked') == false ) {
                        return true;
                    }
                }

                var comment_id = $(this).val();

                comment_ids.push(comment_id);
            });

            if ( comment_ids.length > 0 ) {
                $.ajax({
                    type: "POST",
                    url: approve ? SJ.Core.url("/app/comments/approve") : SJ.Core.url("/app/comments/unapprove"),
                    data: {
                        ids: comment_ids
                    },
                    dataType: "json"
                }).done(function (data) {
                    for ( var key in data ) {
                        var $row = $('#sj-pane-content').find('.row-' + key);

                        if ( data[key].status == 1 ) {
                            if ( approve ) {
                                $row.addClass('comment-is-approved').removeClass('comment-is-not-approved');
                            } else {
                                $row.addClass('comment-is-not-approved').removeClass('comment-is-approved');
                            }
                        }
                    }
                });
            }

        });

        // Comments
        $(document).on('click', '.delete-comments', function () {
            var comment_ids = '';
            $(this).parent().parent().parent().parent().find(':checkbox').each(function () {
                if ( $(this).is(':checked') && !$(this).hasClass('select_all') ) {
                    comment_ids += $(this).val() + '|';
                }
            });
            if ( comment_ids != '' ) {
                SJ.Pane.pull(SJ.Core.url('/app/comments/delete/' + comment_ids));
            }
        });

        // Settings custom url's
        $(document).on('click', 'a#add_customurl', function () {
            var content = '<div class="bs3-form-group">';
            content += '<label class="bs3-col-xs-2 bs3-control-label">' + __('Custom URL') + '</label>';
            content += '<div class="bs3-col-xs-10">';
            content += '<div class="bs3-input-group">';
            content += '<span class="bs3-input-group-addon">http://</span>';
            content += '<input type="text" name="customurl[]" value="" class="bs3-form-control">';
            content += '</div>';
            content += '</div>';
            content += '</div>';

            $('#customurls_container').append(content);
            return false;
        });

        if ( $('.utility .cms-mode-edit').length > 0 ) {
            // Disable PayPal button
            $(document).on('click', '.sj_element_paypal input', function (e) {
                e.preventDefault();
            });
        }

        bodyElement.on('click', '.slideshow-add-caption', function () {
            var caption_last = 0;
            if ( $('.bs3-control-label:contains("Caption")').length > 0 ) {
                caption_last = parseInt($('.bs3-control-label:contains("Caption"):last').html().match(/\d+/)[0]);
            }
            var html = '<div class="bs3-form-group">'
                + '<label class="bs3-col-xs-3 bs3-col-sm-3 bs3-col-md-3 bs3-col-lg-2 bs3-control-label">'
                + 'Caption ' + ++caption_last
                + '</label>'
                + '<div class="bs3-col-xs-10 bs3-col-sm-9 bs3-col-md-9 bs3-col-lg-10">'
                + '<div class="bs3-input-group">'
                + '<input type="text" value="" placeholder="" name="slideshow_captions[]" class="bs3-form-control">'
                + '<span class="bs3-input-group-addon"><a class="slideshow-remove-caption prevent-default" href="#">Remove</a></span>'
                + '</div>'
                + '</div>'
                + '</div>';
            $('#slides-tab').append(html);
        });

        bodyElement.on('click', '.slideshow-remove-caption', function () {
            $(this).parents('div.bs3-form-group').remove();
            var caption_number = 1;
            $('.bs3-control-label:contains("Caption")').each(function () {
                $(this).html('Caption ' + caption_number);
                ++caption_number;
            });
        });
    },
    // Probably we must delete this function :)
    dropdown_menu: function () {
        //add click event for dropdown menus
        $(document).on('click', '#menu ul.dropdown li.parent > a', function (event) {
            event.stopPropagation();

            var x_pos = $(this).parent('li').offset().left + ($('#menu ul.root ul').width() * 2);

            if ( x_pos >= $('body').width() ) {
                $(this).parent('li').children('ul').addClass('right');
            }

            $(this).parent('li').children('ul').toggle();
            event.preventDefault();
        });

        $(document).on('click', 'html', function () {
            $('#menu ul.dropdown li.parent').children('ul').hide();
        });
    },

    Manage: {
        News: {
            init: function () {
                var self = SJ.Sites.Manage.News,
                    $input = $('#news_content');

                self.count_content($input);

                $input.on('input propertychange', function () {
                    self.count_content($(this));
                });
            },

            count_content: function ($this) {
                var $button = $('button[name="filemanager"]');

                if ( $this.val().length > 50000 ) {
                    $button.parents('.bs3-form-group').hide();
                } else {
                    $button.parents('.bs3-form-group').show();
                }
            }
        }
    },
    ipadFix: function () {
        var bodyElement = $('body');
        SJ.Sites.isiPad = navigator.userAgent.match(/iPad/i);
        SJ.Sites.isiPod = navigator.userAgent.match(/iPod/i);
        SJ.Sites.focus = 0;
        if ( SJ.Sites.isiPad != null || SJ.Sites.isiPod != null ) {
            $(window).bind('scroll touchstart load', function () {
                if ( !$('.element').hasClass('mce-edit-focus') ) {
                    SJ.Sites.focus = 0;
                }
                if ( SJ.Sites.focus === 1 ) {
                    var sjbarNode = $('#sj-bar');
                    sjbarNode.css('top', 0);
                    $('.sj-context-placeholder').animate({ top: sjbarNode.height() }, 10);
                    $('.system.context_container_menu').animate({ top: sjbarNode.height() }, 10);

                    var newScroll = $(window).scrollTop();
                    if ( sjbarNode.position().top < 0 ) {
                        sjbarNode.animate({ top: newScroll }, 10);
                        $('.sj-context-placeholder').animate({ top: newScroll + sjbarNode.height() }, 10);
                        $('.system.context_container_menu').animate({ top: newScroll + sjbarNode.height() }, 10);
                    }
                    $('#context_menu_for_page').hide();
                } else {
                    $('#context_menu_for_page').show();
                }
            });
            bodyElement.on('blur', '.element', function () {
                var newScroll = $(window).scrollTop(),
                    sjbarNode = $('#sj-bar');
                if ( $('.element').hasClass('mce-edit-focus') ) {
                    $('#context_menu_for_page').hide();
                    sjbarNode.animate({ top: 0 }, 10);
                    $('.sj-context-placeholder').animate({ top: sjbarNode.height() }, 10);
                    $('.system.context_container_menu').animate({ top: sjbarNode.height() }, 10);
                    return true;
                } else {
                    SJ.Sites.focus = 0;
                    sjbarNode.animate({ top: 0 }, 10);
                    $('.sj-context-placeholder').animate({ top: sjbarNode.height() }, 10);
                    $('.system.context_container_menu').animate({ top: sjbarNode.height() }, 10);
                    $('#context_menu_for_page').show();
                }
            });
            bodyElement.on('focus', '.element', function () {
                SJ.Sites.focus = 1;
                var newScroll = $(window).scrollTop(),
                    sjbarNode = $('#sj-bar');
                if ( sjbarNode.position().top < 0 ) {
                    sjbarNode.animate({ top: newScroll }, 10);
                    $('.sj-context-placeholder').animate({ top: newScroll + sjbarNode.height() }, 10);
                    $('.system.context_container_menu').animate({ top: newScroll + sjbarNode.height() }, 10);
                }
                $('#context_menu_for_page').hide();
            });
            $('#sj-bar').on('click', '*', function () {
                SJ.Sites.focus = 0;
                var sjbarNode = $('#sj-bar');
                sjbarNode.animate({ top: 0 }, 10);
                $('.sj-context-placeholder').animate({ top: sjbarNode.height() }, 10);
                $('.system.context_container_menu').animate({ top: sjbarNode.height() }, 10);
                $('#context_menu_for_page').show();
            });
        }
    }
};


// Init all needed references
$(document).ready(function () {
    SJ.Sites.init();
    SJ.Sites.ipadFix();
});